
const baseUrlDb = 'https://lxxzfrffz5.execute-api.us-east-1.amazonaws.com/Prod';
const baseUrlS3 = 'https://gamerre.s3.us-east-1.amazonaws.com';

const groupDef = 'def';

const xApiKey1 = 'U5Ql6s3fJH7vPvg0h2TMxv6oFKo7A4e5m1oetXZd';

const apis = {
  'users': {
    'base': baseUrlS3,
    'path_ga': '/data/rreusers-enc.json'
  },
  'usersq': {
    'type': 'users',
    'group': groupDef,
    'base': baseUrlDb,
    'path_g1': '/',
    'path_ga': '/query',
    'path_gq': '/query',
    'path_w1': '/',
    'path_wb': '/batch',
    'x-api-key': xApiKey1,
    'bearer': true
  },
  'achievements': {
    'type': 'achievement',
    'group': groupDef,
    _fields: 'user.name',
    'base': baseUrlDb,
    'path_g1': '/',
    'path_ga': '/query',
    'path_gq': '/query',
    'path_w1': '/',
    'path_wb': '/batch',
    'x-api-key': xApiKey1,
    'bearer': true
  },
  'achievementsq': {
    'type': 'achievement',
    'group': groupDef,
    _fields: 'user.name',
    'base': baseUrlDb,
    'path_g1': '/',
    'path_ga': '/query',
    'path_gq': '/query',
    'path_w1': '/query',
    'path_wb': '/query',
    'x-api-key': xApiKey1,
    'bearer': true
  },
  'activities': {
    'type': 'activity',
    'group': groupDef,
    _fields: 'user.name',
    'base': baseUrlDb,
    'path_g1': '/',
    'path_ga': '/query',
    'path_gq': '/query',
    'path_w1': '/',
    'path_wb': '/batch',
    'path_d': '/activity_def_',
    'x-api-key': xApiKey1,
    'bearer': true
  },
  'activitiesq': {
    'type': 'activity',
    'group': groupDef,
    _fields: 'user.name',
    'base': baseUrlDb,
    'path_g1': '/',
    'path_ga': '/query',
    'path_gq': '/query',
    'path_w1': '/query',
    'path_wb': '/query',
    'path_d': '/activity_def_',
    'x-api-key': xApiKey1,
    'bearer': true
  },
  'badges': {
    'base': baseUrlS3,
    'path_ga': '/data/badges.json'
  },
  'scoring': {
    'base': baseUrlS3,
    'path_ga': '/data/scoring.json'
  }
}


const apiFetch = async (endpoint, options = {}) => {
  const response = await fetch(endpoint, options);
  if (!response.ok) {
    let msg = `API request failed with status ${response.status}`;
    console.error(msg);
    let error = {
      error: msg,
      ok: false
    };
    return error;
  }
  return response.json();
};

const methodSet = new Set(['GET', 'PATCH', 'POST', 'PUT', 'DELETE']);

const apiCall = async (method, count, filter, api, path, queryStr, hashStr, data) => {
  if (!method) {
    method = 'GET';
  }
  method = method.toUpperCase();
  if (!methodSet.has(method)) {
    console.error(`Invalid method: ${method}`);
    return;
  }
  let options;
  let aPath = '';
  let apiObj = apis[api];

  if(!apiObj) {
    console.error(`Invalid api: ${api}`);
    return;
  }

  if (method === 'GET') {
    if(count === 1) {
      aPath = apiObj.path_g1;
    } else if(count === -1) {
      if(filter) {
        aPath = apiObj.path_gq;
      } else {
      aPath = apiObj.path_ga;
      }
    } else {
      aPath = apiObj.path_gq;
    }
  } else {
    if(method === 'DELETE') {
      aPath = apiObj.path_d + data;
    } else {
      if(count === 1) {
        aPath = apiObj.path_w1;
      } else {
        aPath = apiObj.path_wb;
      }
    }
  }
    options = {
      method: method,
      headers: {
        'Content-Type': 'application/json'
      }
    };
    if (apiObj['x-api-key']) {
      options.headers['x-api-key'] = apiObj['x-api-key'];
    }
    if (apiObj['bearer']) {
      options.headers['Authorization'] = `Bearer ${window._accessToken}`
    }
    if (data) {
      options.body = JSON.stringify(data);
    }
  
  aPath = aPath ? aPath : '';
  path = path ? path : '';
  
  let url = `${apiObj.base}${aPath}${path}`;
  let defQs;
  defQs = apiObj.group ? `group=${apiObj.group}` : '';
  if(apiObj.type) {
    defQs += (defQs ? '&' : '') + `type=${apiObj.type}`;
  }
  if(apiObj._fields) {
    defQs += (defQs ? '&' : '') + `_fields=${apiObj._fields}`;
  }

  if (queryStr || defQs) {
    console.log('defQs:', defQs, 'queryStr:', queryStr);
    url += '?' + (defQs ? defQs : '') + ((defQs && queryStr) ? '&' : '') + (queryStr ? queryStr : '');
  }
  if (hashStr) {
    url += '#' + hashStr;
  }
  let res = await apiFetch(url, options);
  return res;
};

export { apiCall };

